import { call, put, takeEvery } from 'redux-saga/effects'
import { isString } from 'lodash-es'

import { RealtimeClient } from '../sharedLegacy/utils'

import { getLiveRealtimeData } from './api'

const realtimeClient = new RealtimeClient()

const getRealtimeWorker = (updateAction, updateSiteAction) => {
  function* subscribeToRealtimeUpdates(config) {
    const {
      realtime_url: realtimeUrl,
      realtime_channel: realtimeChannel,
      realtime_channel_site: realtimeChannelSite,
    } = config

    yield call(realtimeClient.connect, realtimeUrl)

    if (isString(updateAction)) {
      const sagaChannel = yield call(
        realtimeClient.subscribeThroughSagaChannel,
        realtimeChannel
      )

      yield takeEvery(sagaChannel, function* onRealtimeUpdate(realtimeData) {
        yield put({ type: updateAction, realtimeData })
      })
    }

    if (isString(updateSiteAction)) {
      const sagaSiteChannel = yield call(
        realtimeClient.subscribeThroughSagaChannel,
        `${realtimeChannelSite}/all_json`
      )

      yield takeEvery(
        sagaSiteChannel,
        function* onRealtimeUpdate(realtimeData) {
          yield put({ type: updateSiteAction, realtimeData })
        }
      )
    }
  }

  function* fetchRealtimeWorker(liveId, presenterToken) {
    const { live } = yield call(getLiveRealtimeData, liveId, presenterToken)

    yield call(subscribeToRealtimeUpdates, live)
  }

  return fetchRealtimeWorker
}

export default getRealtimeWorker
